import type { PropsWithChildren } from 'react';
import { Suspense } from 'react';
import type { RouteProps } from 'react-router-dom';
import { Route } from 'react-router-dom';
import { ViewLoader } from '../ViewLoader/ViewLoader';

export const SuspenseRoute = ({ children, ...routeProps }: PropsWithChildren<RouteProps>) => (
  <Route {...routeProps} render={() => <Suspense fallback={<ViewLoader />}>{children}</Suspense>} />
);
